export const CONNECTING_PREFIX = 'connecting';
export const LOAD_MORE_PAGINATION_PREFIX = 'load-more-pagination';
export const SEARCH_PREFIX = 'search';
export const FINISHED_STEP_PREFIX = 'finished-step';
export const DECOUPLED_REDIRECTION_PREFIX = 'decoupled-redirection';
export const REDIRECT_BUTTON_PREFIX = 'redirect-button';
export const REDIRECTION_PREFIX = 'redirection';
export const SESSION_LOADER_PREFIX = 'session-loader';
export const KLARNA_SESSION_PREFIX = 'klarna-session';
export const REDIRECTING_PREFIX = 'redirecting';
export const ACCOUNT_SELECTION_PREFIX = 'account-selection';
export const FORM_STEP_PREFIX = 'form-step';
export const INTERNAL_ERROR_BOUNDARY_PREFIX = 'internal-error-boundary';
export const ACCOUNT_SELECTION_STEP_PREFIX = 'account-selection-step';
